import React from "react";
import { StepperList } from "@ds/ds-snam/react";
import { IStepper, IStepperList } from "@ds/ds-snam/dist/models/stepper";
import "views/contractView/styles/newElementFormStepperStyles.css";
import { useTranslation } from "react-i18next";
import { IVehicle } from "dataModels/contract";
import { VehicleType } from "shared/constants";

export enum StepperType {
    //NEW_CUSTOMER=0,
    NEW_CONTRACT = 1,
    NEW_TRANSPORT = 2,
    NEW_DRIVER = 3,
    NEW_VEHICLE = 4
}
interface INewCustomerFormStepperProps {
    stepperType: StepperType,
    currentStep: number,
    finalStep: number,
    formData?: IVehicle; // Nuova prop per i dati del veicolo
}
const NewElementFormStepper: React.FC<INewCustomerFormStepperProps> = (props) => {
    const { t } = useTranslation(['contract']);
    const { stepperType, currentStep, finalStep } = props;

    const getTranslationPath = () => {
        let path = "";
        switch (stepperType) {
            case StepperType.NEW_CONTRACT:
                path = 'contract.contractForm';
                break;
            case StepperType.NEW_TRANSPORT:
                path = "transporter.transporterForm";
                break;
            case StepperType.NEW_DRIVER:
                path = "drivers.driverForm";
                break;
            case StepperType.NEW_VEHICLE:
                path = "vehicle.vehicleForm";
                break;
            default:
                path = "";
                break;
        }
        return path;
    }

    const getStepperData = ():IStepperList => {
        let steps:IStepper[] = [
            {
                stepperPhase: "initial",
                stepperText: t(getTranslationPath() + '.stepper.0'),
                stepperCompleted: currentStep >= 1,
                stepperAriaLabel: "stepper 1 aria label"
            },
            {
                stepperPhase: "central",
                stepperText: t(getTranslationPath() + '.stepper.1'),//"Inserimento Documenti"
                stepperCompleted: currentStep >= 2,
                stepperSelected: currentStep === 2,
                stepperAriaLabel: "stepper 2 aria label"
            }
        ];






        if (stepperType === StepperType.NEW_VEHICLE) {
            // Controlla il tipo di veicolo: TRUCK o FLOOR
            const shouldShowProcedures = props.formData?.type !== VehicleType.TRUCK && props.formData?.type !== VehicleType.FLOOR;
            if (shouldShowProcedures) {
                steps.push({
                    stepperPhase: "central",
                    stepperText: t(getTranslationPath() + '.stepper.2'),
                    stepperCompleted: currentStep >= 3,
                    stepperSelected: currentStep === 3,
                    stepperAriaLabel: "stepper 3 aria label"
                });
            }

            steps.push({
                stepperPhase: "central",
                stepperText: t(getTranslationPath() + '.stepper.3'),
                stepperCompleted: currentStep >= 4,
                stepperSelected: currentStep === 4,
                stepperAriaLabel: "stepper 4 aria label"
            },
            {
                stepperPhase: "final",
                stepperText: t(getTranslationPath() + '.stepper.4'),
                stepperCompleted: currentStep === finalStep,
                stepperSelected: currentStep === finalStep,
                stepperAriaLabel: "final step aria label"
            });
            /*steps.push(
                {
                    stepperPhase: "central",
                    stepperText: t(getTranslationPath() + '.stepper.2'),//"Inserimento Procedure (new vehicle only)"
                    stepperCompleted: currentStep >= 3,
                    stepperSelected: currentStep === 3,
                    stepperAriaLabel: "stepper 2 aria label"
                },
                {
                    stepperPhase: "central",
                    stepperText: t(getTranslationPath() + '.stepper.3'),//"Inserimento Certificazioni (new vehicle only)"
                    stepperCompleted: currentStep >= 4,
                    stepperSelected: currentStep === 4,
                    stepperAriaLabel: "stepper 2 aria label"
                },
                {
                    stepperPhase: "final",
                    stepperText: t(getTranslationPath() + '.stepper.4'),//"Riepilogo"
                    stepperCompleted: currentStep === finalStep,
                    stepperSelected: currentStep === finalStep,
                    stepperAriaLabel: "final step aria label"
                }
            )*/


            
        } else if (stepperType === StepperType.NEW_DRIVER) {
            steps.push({
                stepperPhase: "central",
                stepperText: t(getTranslationPath() + '.stepper.2'),//"Inserimento Certificazioni (new vehicle only)"
                stepperCompleted: currentStep >= 3,
                stepperSelected: currentStep === 3,
                stepperAriaLabel: "stepper 2 aria label"
            })
        }
        //final step for all except new vehicle
        if (stepperType !== StepperType.NEW_VEHICLE) {
            steps.push({
                stepperPhase: "final",
                stepperText: t(getTranslationPath() + (stepperType === StepperType.NEW_DRIVER ? '.stepper.3' : '.stepper.2')),//"Riepilogo"
                stepperCompleted: currentStep === finalStep,
                stepperSelected: currentStep === finalStep,
                stepperAriaLabel: "final step aria label"
            })
        }






        const stepperComponentData:IStepperList = {stepperData:steps, stepperVertical:false};
        return stepperComponentData
        
    }

    return <div className="stepperContainer">
        <ol id="stepper">
            <StepperList 
                stepperData={getStepperData()}
            />
        </ol>
    </div>
}

export default NewElementFormStepper;